import ImageWithBasePath from 'components/Common/imageWithBasePath';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import ImageWithoutBasePath from 'components/Common/imageWithoutBasePath';

const LogoInstancesidebar = () => {
    const { workSpaces, user } = useSelector((state: any) => state.authSlice);
    const students = useSelector((state: any) => state.student.students);
    const selectedStudentId = useSelector((state: any) => state.student.selectedStudentId);
    const currentInstanceId = user?.instanceId;
    const currentWorkspace = useMemo(() => (students && selectedStudentId)  ? students?.find((student: any) => String(student.id) === String(selectedStudentId))?.instance : workSpaces?.find((workspace: any) => String(workspace.id) === String(currentInstanceId)), [workSpaces, currentInstanceId, selectedStudentId]);

    return (
        <ul className="mt-2 mb-2">
            <li>
                <Link
                    to="#"
                    className="d-flex align-items-center border bg-white rounded p-2 "
                >
                    <ImageWithoutBasePath
                        src={currentWorkspace?.logo ?? "/assets/img/profiles/fake-image-instance.jpg"}
                        className="avatar avatar-md img-fluid rounded"
                        alt="Profile"
                        onError={(e) => {
                            e.currentTarget.src = "/assets/img/profiles/fake-image-instance.jpg";
                        }}
                    />
                    <span className="text-dark ms-2 fw-normal">
                        {currentWorkspace?.name}
                    </span>
                </Link>
            </li>
        </ul>
    );
};

export default LogoInstancesidebar;